module.exports = wp.compose;


//////////////////
// WEBPACK FOOTER
// external "wp.compose"
// module id = 91
// module chunks = 0